module.exports = __webpack_public_path__ + "img/registration.d89a63cd.svg";